import { Routes } from '~/api/api-routes'
import axios from '~/api/axiosBase'

import { sharedStoreListFetch } from '../../../../zendrop-vue3/src/shared/storeListRequest'

// Routed through the cross-bundle cache so the Vue 2 island reuses the
// request the Vue 3 shell already fired (FE-670).
export const fetchStoreList = async () => {
  return sharedStoreListFetch(() => axios.get(Routes.stores.storeList).then(({ data }) => data))
}

export const fetchStore = async () => {
  return (await axios.get(Routes.stores.store)).data
}

export const fetchStoreListUrls = async () => {
  return (await axios.get(Routes.myStores.storeListUrls)).data.data
}

export const fetchAiStoreData = async () => {
  return (await axios.get(`${Routes.common.config}?keys=prebuildStoreData`)).data.data
}

export const validateStoreUrl = async (data) => {
  return await axios.post(Routes.myStores.validateStoreUrl, data)
}

export const claimStore = async () => {
  return await axios.post(Routes.myStores.claimStore)
}

export const getOrdersCountForStoreProduct = async () => {
  return await axios.post(Routes.linkProduct.getOrdersCountForStoreProduct())
}
export const removeFromImportList = async () => {
  return await axios.post(Routes.products.removeFromImportList())
}

export const removeBundleFromImportList = async () => {
  return await axios.post(Routes.products.removeBundleFromImportList())
}

export const importProductToStore = async () => {
  return await axios.post(Routes.products.importProductToStore())
}

export const importBundleToStore = async () => {
  return await axios.post(Routes.products.importBundleToStore())
}

export const importSubscriptionToStore = async () => {
  return await axios.post(Routes.products.importSubscriptionToStore())
}

export const addToImportList = async () => {
  return await axios.post(Routes.products.importSubscriptionToStore())
}

export const removeFromUserImportListById = async () => {
  return await axios.post(Routes.products.removeFromUserImportListById())
}

export const getSingleImportList = async () => {
  return await axios.post(Routes.products.getSingleImportList())
}

export const getCollectionsAndCategories = async () => {
  return await axios.post(Routes.products.getCollectionsAndCategories())
}

export const importListProducts = async () => {
  return await axios.post(Routes.products.importListProducts())
}

export const removeSubscriptionBox = async () => {
  return await axios.post(Routes.products.removeSubscriptionBox())
}

export const addSubscriptionBoxToImportList = async () => {
  return await axios.post(Routes.products.addSubscriptionBoxToImportList())
}

export const removeSubscriptionBoxFromImport = async () => {
  return await axios.post(Routes.products.removeSubscriptionBoxFromImport())
}

export const getDashboardData = async () => {
  return await axios.get(Routes.other.getDashboardData())
}

export const getDashboardOverviewData = async () => {
  return await axios.get(Routes.other.getDashboardOverviewData())
}

export const addBundleToImportList = async () => {
  return await axios.post(Routes.other.addBundleToImportList())
}

export const checkShippingTemplate = async () => {
  return await axios.post(Routes.other.checkShippingTemplate())
}

export const getStoreProductsIssuesCount = async () => {
  return await axios.get(Routes.other.getStoreProductsIssuesCount())
}
